import React from "react";

/** Small fish mark for navbar branding */
function FishIcon({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2 10c0-4.4 3.6-8 8.2-8 2.1 0 4 .7 5.5 1.9L24 1.5V18.5l-8.3-3.4a8.1 8.1 0 01-5.5 1.9C5.6 18 2 14.4 2 10zm7.2-2.8a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2z" />
    </svg>
  );
}

export default FishIcon;
